import React, { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';

const EventDetails = ({ event, userId, onBack }) => {
  const [bookmakers, setBookmakers] = useState([]);
  const [firstColumn, setFirstCol] = useState([]);
  const [secondColumn, setSecondCol] = useState([]);
  const [thirdColumn, setThirdCol] = useState([]);
  const [selectedBookmakerId, setSelectedBookmakerId] = useState(null);
  const [note, setNote] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editedEventName, setEditedEventName] = useState(event.event);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false); // New state to track fetching
  useEffect(() => {
    const fetchBookmakers = async () => {
      if (!hasFetched) {
        setLoading(true); // Set loading to true before the first fetch
      }
      try {
        const response = await fetch(`https://focusprojectsoft.com/api/event-bookmakers/${event.id}`);
        const data = await response.json();
        setBookmakers(data.bookmakers);
        var countNm = Math. ceil(data.bookmakers.length / 3 );
        const firstColumn = data.bookmakers.slice(0, countNm);
        const secondColumn = data.bookmakers.slice(countNm, countNm*2);
        const thirdColumn = data.bookmakers.slice(countNm*2, countNm*3);
        console.log(secondColumn);
        setFirstCol(firstColumn)
        setSecondCol(secondColumn)
        setThirdCol(thirdColumn)

        for (var odd of data.odds) {
          document.querySelectorAll("thead th")[odd.colIndex].textContent = odd.header;
          document.querySelectorAll("tbody td")[odd.colIndex].textContent = odd.odd;
        }

        document.querySelector(".client-detail").innerText = data.event_client + " " + ((data.client_note != null)?"(" + data.client_note + ")":'');
        setHasFetched(true); // Set hasFetched to true after successful fetch
        setOddsColors();
      } catch (error) {
        console.error('Error fetching bookmakers:', error);
      } finally {
        if (!hasFetched) {
          setLoading(false); // Set loading to false after the first fetch
        }
      }
    };

    fetchBookmakers();
    const intervalId = setInterval(fetchBookmakers, 1500);

    return () => clearInterval(intervalId);
   
  }, [event.id, hasFetched]); // Add hasFetched to dependencies

  const handleToggle = async (bookmakerId) => {
    if (event.confirm) {
      alert('Event has been confirmed.');
    } else {
      var datetimeVal = document.querySelectorAll("input.MuiInputBase-input.MuiOutlinedInput-input")[0].value;
      if (event.datetime === null && datetimeVal === '') {
        alert('You must set the datetime first');
      } else {
        const updatedBookmakers = bookmakers.map(bookmaker => {
          if (bookmaker.id === bookmakerId) {
            return { ...bookmaker, checked: !bookmaker.checked };
          }
          return bookmaker;
        });
        setBookmakers(updatedBookmakers);
        setLoading(true);
        await fetch(`https://focusprojectsoft.com/api/update-bookmaker/${bookmakerId}/${event.id}`, {
          method: 'POST',
          body: JSON.stringify({ checked: !bookmakers.find(b => b.id === bookmakerId).checked }),
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setLoading(false);
      }
    }

  };


  const setOddsColors = () => {
    var referenceOdd = document.querySelectorAll("tbody td")[0];
    var otherOdds = document.querySelectorAll("tbody td");
    if (referenceOdd.textContent != '') {
      referenceOdd.classList.add("reference");
      for (var i = 1; i < otherOdds.length; i++ ) {
        if (otherOdds[i].textContent != '') {
          otherOdds[i].classList = []
         if (parseFloat(otherOdds[i].textContent) >= parseFloat(referenceOdd.textContent)) {
          otherOdds[i].classList.add("bigger-odd");
         } else if (parseFloat(otherOdds[i].textContent) < parseFloat(referenceOdd.textContent)) {
          otherOdds[i].classList.add("smaller-odd");
         }
        }
      }
    }
    
    
  }

  const handleConfirmChange = async (e) => {
    const checked = e.target.checked;
  
    // Check if all .input-bookmaker are checked
    // const allChecked = Array.from(document.querySelectorAll('.input-bookmaker')).every(input => input.checked);
  
    // Set confirmation only if all inputs are checked
    // if (allChecked) {
    //   setIsConfirmed(checked);
      if (checked) {
        setLoading(true); // Set loading to true when the request starts
        try {
          const response = await fetch(`https://focusprojectsoft.com/api/event-confirm/${event.id}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              confirm: checked,
              userId: userId,
            }),
          });
  
          // Check if the API call was successful
          if (response.ok) {
            // Update local event state to reflect confirmation
            event.confirm = true; // Or set it using a state management solution if applicable
          } else {
            alert('Failed to confirm the event.');
          }
        } catch (error) {
          console.error('Error confirming event:', error);
          alert('An error occurred while confirming the event.');
        } finally {
          setLoading(false); // Set loading to false when the request completes
        }
      } else {
        setLoading(true); // Set loading to true when the request starts
        try {
          const response = await fetch(`https://focusprojectsoft.com/api/event-confirm/${event.id}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              confirm: false,
              userId: userId,
            }),
          });
  
          // Check if the API call was successful
          if (response.ok) {
            // Update local event state to reflect confirmation
            event.confirm = false; // Or set it using a state management solution if applicable
          } else {
            alert('Failed to confirm the event.');
          }
        } catch (error) {
          console.error('Error confirming event:', error);
          alert('An error occurred while confirming the event.');
        } finally {
          setLoading(false); // Set loading to false when the request completes
        }
      }
  };
  

  const handleNoteClick = (bookmakerId, currentNote) => {
    if (event.confirm) {
      alert('Event has been confirmed.');
    } else {
      var datetimeVal = document.querySelectorAll("input.MuiInputBase-input.MuiOutlinedInput-input")[0].value;
      if (event.datetime === null && datetimeVal === '') {
        alert('You must set the datetime first');
      } else {
        setSelectedBookmakerId(bookmakerId);
        setNote(currentNote || '');
      }
    
    }

  };

  const handleNoteSubmit = async (e) => {
    e.preventDefault();
    await fetch(`https://focusprojectsoft.com/api/client-event/note/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        eventId: event.id,
        bookmakerId: selectedBookmakerId,
        note: note,
        userId: userId,
      }),
    });

    setSelectedBookmakerId(null);
    setNote('');
  };

  const handleCancel = () => {
    setSelectedBookmakerId(null);
    setNote('');
  };

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleEventNameChange = (e) => {
    setEditedEventName(e.target.value);
  };

  const handleSaveEventName = async (e) => {
    e.preventDefault();
    await fetch(`https://focusprojectsoft.com/api/update-client-event/${event.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ eventName: editedEventName }),
    });
    setIsEditing(false);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowSubmitButton(true);
  };

  const handleDateSubmit = async (e) => {
    e.preventDefault();
    if (selectedDate) {
      await fetch(`https://focusprojectsoft.com/api/event-time/update/${event.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventDate: selectedDate.toISOString(),
        }),
      });

      setShowSubmitButton(false);
      setSelectedDate(selectedDate);
    }
  };

  const handleInputTable = async (e, colIndex) => {
    const value = e.target.textContent; // Get the current value of the cell
    var header = document.querySelectorAll("thead th")[colIndex].textContent;

    await fetch(`https://focusprojectsoft.com/api/telegram-event/set-odd`, {
      method: 'POST',
      body: JSON.stringify({ 
        eventId: event.id,
        odd: value,
        colIndex: colIndex,
        header: header,
       }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    console.log({ 
      eventId: event.id,
      odd: value,
      colIndex: colIndex,
      header: header,
    });
  };

  const handleInputHeader = async (e, indx) => {
    var colIndex = 10 + indx;
    const value = e.target.textContent; // Get the current value of the cell
    var header = document.querySelectorAll("thead th")[colIndex].textContent;

    await fetch(`https://focusprojectsoft.com/api/telegram-event/set-odd`, {
      method: 'POST',
      body: JSON.stringify({ 
        eventId: event.id,
        odd: '',
        colIndex: colIndex,
        header: header,
       }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    console.log({ 
      eventId: event.id,
      odd: value,
      colIndex: colIndex,
      header: header,
    });
  };
  

  return (
    <div>
    {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <div>Loading...</div>
        </div>
      )}
      <button className="go-back-button" style={{ margin: '20px' }} onClick={onBack}>⇇ Go Back</button>

      <h3 style={{ marginLeft: '20px' }} className='client-detail'></h3>
      <div className='event-details' style={{ display: 'flex', margin: '20px' }}>
        <div style={{ flex: '0 0 20%', marginRight: '10px' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Select Date and Time"
              value={selectedDate || (event.datetime ? dayjs(event.datetime) : null)}
              onChange={handleDateChange}
              renderInput={(params) => (
                <input
                  {...params}
                  style={{
                    color: 'white',
                    backgroundColor: 'transparent',
                    border: '1px solid white',
                    padding: '5px',
                    borderRadius: '4px',
                  }}
                />
              )}
              ampm={false}
              sx={{
                '& .MuiInputBase-root': {
                  color: 'white',
                },
                '& .MuiInputLabel-root': {
                  color: 'white',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'white',
                },
                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
              }}
            />
          </LocalizationProvider>

          {showSubmitButton && (
            <button onClick={handleDateSubmit} style={{ marginLeft: '10px' }}>Update Date</button>
          )}
        </div>
        
        <div style={{ flex: '0 0 10%', display: 'flex', alignItems: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'baseline' }}>
            <input
              type="checkbox"
              checked={event.confirm}
              onChange={handleConfirmChange}
              style={{ marginRight: '10px', cursor: 'pointer' }}
            />
            <span style={{
              backgroundColor: event.confirm ? 'rgb(0 148 149)' : 'rgb(161 0 20)',
              borderRadius: '5px',
              padding: '5px 10px',
              color: 'white',
              fontWeight: 'bold',
              transition: 'background 0.3s',
              cursor: 'pointer',
            }}>
              Confirm
            </span>
          </label>
        </div>
        <div style={{ flex: '0 0 70%', display: 'flex', alignItems: 'center', border: '1px solid white', overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }} className="equal-width-table">
            <thead>
              <tr style={{ backgroundColor: '#078555', color: 'white', fontWeight: 'bolder', fontSize: 'large' }}>
                {['Req.', 'Pinn', 'Sing', 'IGC', 'Bet365', 'EuroB', 'GoldB', 'Sisal', 'SRB', 'GR'].map((header, index) => (
                  <th key={index} style={{ padding: '10px', border: '1px solid white' }}>{header}</th>
                ))}

                {Array(5).fill(null).map((_, colIndex) => (
                  <th
                   key={colIndex} 
                   style={{ padding: '10px', border: '1px solid white' }} 
                   contentEditable
                   onInput={(e) => handleInputHeader(e, colIndex)}
                   ></th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {Array(14).fill(null).map((_, colIndex) => (
                  <td
                    key={colIndex}
                    style={{ padding: '10px', border: '1px solid white' }}
                    contentEditable
                    onInput={(e) => handleInputTable(e, colIndex)}
                  >
                    {/* Optionally, you can set an initial value */}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <h2 style={{ margin: '20px' }}>
        {isEditing ? (
          <form onSubmit={handleSaveEventName} style={{ display: 'inline' }}>
            <input
              type="text"
              value={editedEventName}
              onChange={handleEventNameChange}
              style={{ marginRight: '10px' }}
            />
            <button type="submit" style={{ cursor: 'pointer' }}>
              <i className="fa">&#xf00c;</i>
            </button>
          </form>
        ) : (
          <>
            {editedEventName} 
            <span id="edit-pencil" style={{ cursor: 'pointer' }} onClick={handleEditToggle}>
              <i className="fa">&#8195;&#xf040;</i>
            </span>
          </>
        )}
      </h2>

      <ul style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', listStyleType: 'none', padding: 0, marginLeft: '20px', }}>
       
        {/* FIRST COLUMN */}
        <div>
        {firstColumn.map(bookmaker => (
          <li key={bookmaker.id} style={{ marginBottom: '20px',}}>
            <div style={{ alignItems: 'center' }}>
              <label style={{ marginRight: '10px' }}>
                <input
                className="input-bookmaker"
                  type="checkbox"
                  checked={bookmaker.checked}
                  onChange={() => handleToggle(bookmaker.id)}
                  style={{ display: 'none' }}
                />
                <span style={{
                  width: '40px',
                  height: '20px',
                  background: bookmaker.checked ? 'rgb(0 148 149)' : 'rgb(161 0 20)',
                  borderRadius: '20px',
                  position: 'relative',
                  display: 'inline-block',
                  cursor: 'pointer',
                  transition: 'background 0.3s',
                }}>
                  <span style={{
                    width: '18px',
                    height: '18px',
                    background: 'white',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '1px',
                    left: bookmaker.checked ? '22px' : '2px',
                    transition: 'left 0.3s',
                  }} />
                </span>
              </label>
              <span style={{ marginRight: '10px' }}>{bookmaker.name}</span>
              <span style={{
                backgroundColor: '#f0f0f0',
                borderRadius: '5px',
                padding: '2px 6px',
                fontSize: '0.9em',
                color: '#333',
                marginLeft: '10px',
                border: '1px solid #ccc',
                cursor: 'pointer',
              }} onClick={() => handleNoteClick(bookmaker.id, bookmaker.note)}>
                📝 <b>{bookmaker.note}</b>
              </span>
              
              <p style={{ margin: '0', marginLeft: '3rem', color: '#00ffd278', }}><small>{bookmaker.book_note}</small></p>
            </div>
            {selectedBookmakerId === bookmaker.id && (
              <form onSubmit={handleNoteSubmit} style={{ marginTop: '10px' }}>
                <input
                  type="text"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Type your note here"
                  style={{
                    marginRight: '10px',
                    width: '200px',
                    padding: '5px',
                  }}
                />
                <button type="submit">Save Note</button>
                <button type="button" onClick={handleCancel} style={{ marginLeft: '10px' }}>Cancel</button>
              </form>
            )}
          </li>
        ))}
        </div>
        
        {/* SECOND COLUMN */}
        <div>
        {secondColumn.map(bookmaker => (
          <li key={bookmaker.id} style={{ marginBottom: '20px',}}>
            <div style={{ alignItems: 'center' }}>
              <label style={{ marginRight: '10px' }}>
                <input
                className="input-bookmaker"
                  type="checkbox"
                  checked={bookmaker.checked}
                  onChange={() => handleToggle(bookmaker.id)}
                  style={{ display: 'none' }}
                />
                <span style={{
                  width: '40px',
                  height: '20px',
                  background: bookmaker.checked ? 'rgb(0 148 149)' : 'rgb(161 0 20)',
                  borderRadius: '20px',
                  position: 'relative',
                  display: 'inline-block',
                  cursor: 'pointer',
                  transition: 'background 0.3s',
                }}>
                  <span style={{
                    width: '18px',
                    height: '18px',
                    background: 'white',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '1px',
                    left: bookmaker.checked ? '22px' : '2px',
                    transition: 'left 0.3s',
                  }} />
                </span>
              </label>
              <span style={{ marginRight: '10px' }}>{bookmaker.name}</span>
              <span style={{
                backgroundColor: '#f0f0f0',
                borderRadius: '5px',
                padding: '2px 6px',
                fontSize: '0.9em',
                color: '#333',
                marginLeft: '10px',
                border: '1px solid #ccc',
                cursor: 'pointer',
              }} onClick={() => handleNoteClick(bookmaker.id, bookmaker.note)}>
                📝 <b>{bookmaker.note}</b>
              </span>
              
              <p style={{ margin: '0', marginLeft: '3rem', color: '#00ffd278', }}><small>{bookmaker.book_note}</small></p>
            </div>
            {selectedBookmakerId === bookmaker.id && (
              <form onSubmit={handleNoteSubmit} style={{ marginTop: '10px' }}>
                <input
                  type="text"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Type your note here"
                  style={{
                    marginRight: '10px',
                    width: '200px',
                    padding: '5px',
                  }}
                />
                <button type="submit">Save Note</button>
                <button type="button" onClick={handleCancel} style={{ marginLeft: '10px' }}>Cancel</button>
              </form>
            )}
          </li>
        ))}
        </div>

        {/* THIRD COLUMN */}
        <div>
        {thirdColumn.map(bookmaker => (
          <li key={bookmaker.id} style={{ marginBottom: '20px',}}>
            <div style={{ alignItems: 'center' }}>
              <label style={{ marginRight: '10px' }}>
                <input
                className="input-bookmaker"
                  type="checkbox"
                  checked={bookmaker.checked}
                  onChange={() => handleToggle(bookmaker.id)}
                  style={{ display: 'none' }}
                />
                <span style={{
                  width: '40px',
                  height: '20px',
                  background: bookmaker.checked ? 'rgb(0 148 149)' : 'rgb(161 0 20)',
                  borderRadius: '20px',
                  position: 'relative',
                  display: 'inline-block',
                  cursor: 'pointer',
                  transition: 'background 0.3s',
                }}>
                  <span style={{
                    width: '18px',
                    height: '18px',
                    background: 'white',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '1px',
                    left: bookmaker.checked ? '22px' : '2px',
                    transition: 'left 0.3s',
                  }} />
                </span>
              </label>
              <span style={{ marginRight: '10px' }}>{bookmaker.name}</span>
              <span style={{
                backgroundColor: '#f0f0f0',
                borderRadius: '5px',
                padding: '2px 6px',
                fontSize: '0.9em',
                color: '#333',
                marginLeft: '10px',
                border: '1px solid #ccc',
                cursor: 'pointer',
              }} onClick={() => handleNoteClick(bookmaker.id, bookmaker.note)}>
                📝 <b>{bookmaker.note}</b>
              </span>
              
              <p style={{ margin: '0', marginLeft: '3rem', color: '#00ffd278', }}><small>{bookmaker.book_note}</small></p>
            </div>
            {selectedBookmakerId === bookmaker.id && (
              <form onSubmit={handleNoteSubmit} style={{ marginTop: '10px' }}>
                <input
                  type="text"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Type your note here"
                  style={{
                    marginRight: '10px',
                    width: '200px',
                    padding: '5px',
                  }}
                />
                <button type="submit">Save Note</button>
                <button type="button" onClick={handleCancel} style={{ marginLeft: '10px' }}>Cancel</button>
              </form>
            )}
          </li>
        ))}
        </div>

      </ul>
    </div>
  );
};

export default EventDetails;
